import {FC} from 'react';

import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {config} from 'config/env';
import {useAppSelector} from 'hooks';
import {useAppMode} from 'hooks/useAppMode';
import {useBasketCalculations} from 'hooks/useBasketCalculations';
import {formatPriceWithCurrency} from 'utils';

import {StyledBasketInfoBanner, StyledBasketSuccessBanner} from '../styled';

export interface BasketFreeDeliveryBannerProps {
  shippingFee?: number;
  noItemSelected: boolean;
  is3P?: boolean;
}

export const BasketFreeDeliveryBanner: FC<BasketFreeDeliveryBannerProps> = (props) => {
  const {t} = useTranslation();
  const {basket} = useAppSelector((state) => state?.basket);
  const {freeThreshold} = useBasketCalculations();

  const {isStorePickup} = useAppMode();

  const i18nKeysSuffix = 'V2';
  let message: string | undefined;

  if (!basket || !basket?.prices || !basket?.shippingRule) {
    return null;
  }

  const makroSeller = basket.prices?.priceBreakdown?.find((pb) => pb.is3PSeller === false);
  const remaining1PSpend = freeThreshold - Number(makroSeller?.subTotalAfterPromotion);

  const hasMinimumBasketAmount = basket.prices.minimumBasket - basket.prices.totalDisplayPricePostVoucher <= 0;
  const basketTotal =
    basket.prices.totalDisplayPricePostVoucher -
    (basket.prices.totalAlcoholPrice || 0) -
    (basket.prices.totalLegalRestrictedPrice || 0);

  const isCongratsBanner = props.shippingFee === 0;

  if (
    !hasMinimumBasketAmount ||
    props?.noItemSelected ||
    !basketTotal ||
    ((!!basket.prices.totalAlcoholPrice || !!basket.prices.totalLegalRestrictedPrice) && !isCongratsBanner)
  ) {
    return null;
  }
  if (remaining1PSpend > 0 && remaining1PSpend < freeThreshold && !isCongratsBanner) {
    message = t(`message.getFreeDeliveryV3`, {
      freeDeliverySpend: formatPriceWithCurrency(remaining1PSpend, basket.priceUnit),
      deliveryFee: formatPriceWithCurrency(props.shippingFee || basket.prices.shippingFee, basket.priceUnit)
    });
  }
  if (isCongratsBanner) {
    message = t(`message.gotFreeDelivery${i18nKeysSuffix}`);
  }

  if (!message || (config.ENABLE_UNIFY_BASKET && isStorePickup)) {
    return null;
  }

  if (!isCongratsBanner && !props.is3P) {
    return (
      <StyledBasketInfoBanner>
        <Typography component={'p'} variant="body2" dangerouslySetInnerHTML={{__html: message}} />
      </StyledBasketInfoBanner>
    );
  }

  return (
    <StyledBasketSuccessBanner>
      <Typography component={'p'} variant="body2" dangerouslySetInnerHTML={{__html: message}} />
    </StyledBasketSuccessBanner>
  );
};

BasketFreeDeliveryBanner.displayName = `BasketFreeDeliveryBanner`;
